// /api/trial/get-all-trials-name

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";


export const getTrailsName = createAsyncThunk('/getTrailsName', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${ENDPOINTS.TRIALS.GET_TRIAL_NAME}`)
        return response.data;

    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getTrailsNameSlice = createSlice(
    {
        name: "trials",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getTrailsName.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getTrailsName.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getTrailsName.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getTrailsNameSlice.reducer;